import $ from 'jquery';
import flatten from 'lodash/flatten';
import uniq from 'lodash/uniq';

const tabsWidget = (config) => {
  const container = $(config.container);
  const allPosts = uniq(flatten(config.tabs.map((tab) => tab.posts)));

  return {
    getConfiguration: (options) =>
      Object.assign({}, options, {
        disjunctiveFacets: [config.facet]
      }),
    init: (options) => {
      const helper = options.helper;
      allPosts.forEach((value) => {
        helper.addDisjunctiveFacetRefinement('post_type_label', value);
      });
      helper.search();

      container.html(`
        <nav class="tabs__nav">
          <ul>
            <li><button data-posts="${allPosts.join(
              ','
            )}">All <span class="tabs__label">0</span></button></li>
            ${config.tabs
              .map(
                (tab) => `
                  <li>
                    <button data-posts="${tab.posts.join(',')}">${
                  tab.title
                } <span class="tabs__label">0</span></button>
                  </li>
                `
              )
              .join('')}
          </ul>
        </nav>
      `);

      container.find('button').first().addClass('toggle__switch--on');

      container.find('button').on('click', (event) => {
        container.find('.toggle__switch--on').removeClass('toggle__switch--on');
        $(event.currentTarget).addClass('toggle__switch--on');
        const posts = $(event.currentTarget).data('posts').split(',');
        helper.clearRefinements();
        posts.forEach((value) => {
          helper.addDisjunctiveFacetRefinement('post_type_label', value);
        });
        helper.search();
      });
    },
    render: (options) => {
      const data =
        options.results.disjunctiveFacets.length > 0
          ? options.results.disjunctiveFacets[0].data
          : undefined;

      if (!data) {
        container.find('button .tabs__label').html('0');
      } else {
        container.find('button').each((index, elem) => {
          const button = $(elem);
          const posts = button.data('posts').split(',');
          let count = 0;
          posts.forEach((value) => {
            count = count + (data[value] || 0);
          });
          button.find('.tabs__label').html(count);
        });
      }
    }
  };
};

export default tabsWidget;
